import { render, staticRenderFns } from "./MaterialConsumption.vue?vue&type=template&id=4388183b"
import script from "./MaterialConsumption.vue?vue&type=script&lang=js"
export * from "./MaterialConsumption.vue?vue&type=script&lang=js"
import style0 from "./MaterialConsumption.vue?vue&type=style&index=0&id=4388183b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports